import React, { forwardRef } from "react";

import { StyledSpinnerLoader } from "./Styles";

export interface SpinnerLoaderProps {
  /** Loader circumference size */
  radius?: number;
  /** Stroke width of the loader */
  stroke?: number;
  /** Active color of spinning loader */
  activeStrokeColor?: string;
  /** Percentage of the circle which the active color takes */
  activeColorPercentage?: "25%" | "50%" | "75%";
  /** Inactive color of spinning loader */
  inactiveStrokeColor?: string;
  /** Rotate speed of animation in seconds */
  rotateDurationInSeconds?: number;
}

export const SpinnerLoader = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div"> & SpinnerLoaderProps
>(
  (
    {
      radius = 10,
      stroke = 2,
      activeStrokeColor = "var(--color-secondary)",
      inactiveStrokeColor = "var(--color-theme-transparent-300)",
      activeColorPercentage = "25%",
      rotateDurationInSeconds = 0.75,
      className,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledSpinnerLoader
        ref={ref}
        className={className}
        $diameter={radius * 2}
        $stroke={stroke}
        $activeStrokeColor={activeStrokeColor}
        $inactiveStrokeColor={inactiveStrokeColor}
        $activeColorPercentage={activeColorPercentage}
        $rotateDurationInSeconds={rotateDurationInSeconds}
        {...rest}
      />
    );
  }
);

SpinnerLoader.displayName = "SpinnerLoader";
